import { Controller } from '@hotwired/stimulus';
import { Sortable } from 'sortablejs';
import { useEventListener } from 'stimulus-library/dist';

export default class extends Controller {
  static values = {
    handle: String,
  };

  get sortableInputs() {
    return this.element.querySelectorAll('input[data-sortable-value]');
  }

  connect() {
    useEventListener(this, this.element, 'nested-form:added', this.recalculateDisplayOrders);
    const self = this;
    this.sortable = new Sortable(this.element, {
      fallbackTolerance: 10,
      animation: 150,
      filter: '[data-sortable-ignore]',
      onStart: () => self.element.classList.add('sortable-active'),
      onEnd: () => self.element.classList.remove('sortable-active'),
      onSort: () => self.recalculateDisplayOrders(),
      onMove: (e) => !(e.related.dataset.sortableIgnore === 'true' || e.related.dataset.sortableIgnore === ''),
    });
    this.recalculateDisplayOrders();
  }

  disconnect() {
    this.sortable?.destroy();
  }

  recalculateDisplayOrders() {
    this.sortableInputs.forEach((el, index) => el.value = index + 1);
  }

  prev(event) {
    const { target } = event;
    let elToMove = target;
    const self = this;
    const moveElement = (el) => {
      if (el.previousElementSibling) {
        el.previousElementSibling.before(el);
        self.recalculateDisplayOrders();
      }
    };

    if (this.hasHandleValue) {
      while (!elToMove.matches(this.handleValue)) {
        const parent = elToMove.parentElement;

        if (parent === this.element) {
          moveElement(elToMove);
          return;
        }
        elToMove = parent;
      }
      moveElement(elToMove);
    } else {
      while (elToMove.parentElement !== this.element) {
        elToMove = elToMove.parentElement;
      }
      moveElement(elToMove);
    }
  }

  next(event) {
    const { target } = event;
    let elToMove = target;
    const self = this;
    const moveElement = (el) => {
      if (el.nextElementSibling) {
        el.nextElementSibling.after(el);
        self.recalculateDisplayOrders();
      }
    };

    if (this.hasHandleValue) {
      while (!elToMove.matches(this.handleValue)) {
        const parent = elToMove.parentElement;

        if (parent === this.element) {
          moveElement(elToMove);
          return;
        }
        elToMove = parent;
      }
      moveElement(elToMove);
    } else {
      while (elToMove.parentElement !== this.element) {
        elToMove = elToMove.parentElement;
      }
      moveElement(elToMove);
    }
  }
}
